export function dimension(langInfo, value) {
  return langInfo.dimension.replace("__x__", value)
}

export function weight(langInfo, value) {
  return langInfo.weight.replace("__x__", value)
}

export function distance(langInfo, value) {
  return langInfo.distanceUnit.replace(
    "__x__",
    Math.floor(value * langInfo.distanceUnitConversionRate),
  )
}
